import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ContactForm from "./ContactForm";
import GlobalStyles from "./GlobalStyles";

export default function AppLayout() {
  return (
    <>
      <GlobalStyles />
      <Navbar />
      <Outlet />
      <ContactForm />
      <Footer />
    </>
  );
}
